// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/one-in-sixty-off-course.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/one-in-sixty-off-course/one-in-sixty-off-course.js';

mount([g0]);
